import 'css-chunk:src/components/CoinsDisplay.module.scss';export default {
  "coins": "_coins_uv7fo_1",
  "copper": "_copper_uv7fo_9",
  "silver": "_silver_uv7fo_14",
  "gold": "_gold_uv7fo_18",
  "platinum": "_platinum_uv7fo_22",
  "dementia": "_dementia_uv7fo_27",
  "void": "_void_uv7fo_32",
  "lustre": "_lustre_uv7fo_37",
  "starfire": "_starfire_uv7fo_41",
  "dreadlo": "_dreadlo_uv7fo_45",
  "godshard": "_godshard_uv7fo_49",
  "sunder": "_sunder_uv7fo_54",
  "tydal": "_tydal_uv7fo_58",
  "marbiglass": "_marbiglass_uv7fo_62",
  "orberal": "_orberal_uv7fo_67",
  "eclipse": "_eclipse_uv7fo_71"
};